export default __webpack_public_path__ + "static/media/2-3-selectFacilityType.bfbc47c7.png";